module.exports = __webpack_public_path__ + "img/logo.31412cbe.png";